// The atomic validation types are:

export const ValidationType = {
	Liveness: 'Liveness', //
	DocumentVerification: 'DocumentVerification',
	FaceMatch: 'FaceMatch',
	Regex: 'Regex',
} as const;
export type ValidationType = (typeof ValidationType)[keyof typeof ValidationType];

/* -------------------------------------------------------------------------------------------------------------- */
// The validation group types are: (combination of atomic validation types)
/* ------ Liveness validation group types: ------ */
export const LivenessValidationGroupTypes = {
	Liveness: 'Liveness', //
	LivenessMatchMetadataImage: 'LivenessMatchMetadataImage',
	LivenessDocumentVerification: 'LivenessDocumentVerification',
	LivenessDocumentVerificationStaticValue: 'LivenessDocumentVerificationStaticValue',
	LivenessDocumentVerificationMetaTagValue: 'LivenessDocumentVerificationMetaTagValue',
} as const;
/* ------ Document verification validation group types: ------ */
export const DocumentVerificationValidationGroupTypes = {
	DocumentVerification: 'DocumentVerification',
	DocumentVerificationStaticValue: 'DocumentVerificationStaticValue',
	DocumentVerificationMetaTagValue: 'DocumentVerificationMetaTagValue',
} as const;
/* ------ All validation group types: ------ */
export const ValidationGroupType = {
	...LivenessValidationGroupTypes,
	...DocumentVerificationValidationGroupTypes,
	Regex: 'Regex',
} as const;
export type ValidationGroupType = (typeof ValidationGroupType)[keyof typeof ValidationGroupType];
/* -------------------------------------------------------------------------------------------------------------- */
// Mapper	from a validation group type to a validation type array:
export const ValidationGroupToValidationTypes: Record<ValidationGroupType, ValidationType[]> = {
	[ValidationGroupType.Liveness]: [ValidationType.Liveness],
	[ValidationGroupType.LivenessMatchMetadataImage]: [ValidationType.Liveness, ValidationType.FaceMatch],
	[ValidationGroupType.LivenessDocumentVerification]: [ValidationType.Liveness, ValidationType.DocumentVerification, ValidationType.FaceMatch],
	[ValidationGroupType.LivenessDocumentVerificationStaticValue]: [ValidationType.Liveness, ValidationType.DocumentVerification, ValidationType.FaceMatch],
	[ValidationGroupType.LivenessDocumentVerificationMetaTagValue]: [ValidationType.Liveness, ValidationType.DocumentVerification, ValidationType.FaceMatch],
	/* -------------------------------------------------- */
	[ValidationGroupType.DocumentVerification]: [ValidationType.DocumentVerification],
	[ValidationGroupType.DocumentVerificationStaticValue]: [ValidationType.DocumentVerification],
	[ValidationGroupType.DocumentVerificationMetaTagValue]: [ValidationType.DocumentVerification],
	[ValidationGroupType.Regex]: [ValidationType.Regex],
};

export function getValidationTypeOrdersByGroupType(groupType: ValidationGroupType): Record<ValidationType, number> {
	if (!groupType) return null;
	const validationTypeOrders = {} as Record<ValidationType, number>;
	const validationTypes = ValidationGroupToValidationTypes[groupType];
	validationTypes.forEach((validationType, index) => {
		validationTypeOrders[validationType] = index + 1;
	});
	return validationTypeOrders;
}
